/* 0.47.20 - A card's own fill and stroke (Information, Guide and Payment
 * card): a Henaket token or '#RRGGBB', empty for the card's Henaket
 * colors. Passed to the card as --card-bg and --card-stroke, which its
 * stylesheet reads with the Henaket value as the fallback. */
import { colorCss } from './colorCss';

export function cardColorVars(fill, stroke) {
  const out = {};
  const f = colorCss(fill);
  const s = colorCss(stroke);
  if (f) out['--card-bg'] = f;
  if (s) out['--card-stroke'] = s;
  return Object.keys(out).length ? out : undefined;
}
